// file create during webpack build by manifest plugin
// @ts-ignore
import addPanelEntriesManifest from './manifest.json';

export default (locale: string) => {
  const key =
    `addPanelSections${locale.toUpperCase()}.js` as keyof typeof addPanelEntriesManifest;
  return key in addPanelEntriesManifest;
};
